/**
 * Noom Button Effects — Standalone JS
 *
 * Applies box shadow and gradient effects to buttons based on
 * data-* attributes on <html> element (set by Liquid in theme.liquid).
 *
 * Expected data attributes on document.documentElement:
 *   data-enable-box-shadow="true|false"
 *   data-shadow-intensity="1-5"
 *   data-enable-gradient="true|false"
 *   data-enable-gradient-shine="true|false"
 *
 * Load with: <script src="noom-button-effects.js" defer></script>
 */

// Read settings from data-* attributes on <html>
const enableBoxShadow = document.documentElement.dataset.enableBoxShadow === 'true';
const shadowIntensity = parseInt(document.documentElement.dataset.shadowIntensity || '3');
const enableGradient = document.documentElement.dataset.enableGradient === 'true';
const enableGradientShine = document.documentElement.dataset.enableGradientShine === 'true';

// If neither effect is enabled, exit early
if (enableBoxShadow || enableGradient) {

  // Define button selectors that should receive enhanced effects
  const buttonSelectors = [
    '.button-global-style',
    '.use-global-button-styling',
    '.button',
    '.btn',
    'button[type="submit"]',
    'input[type="submit"]',
    '.product-form__submit',
    '.shop-add-to-cart-button',
    '.cart__checkout-button',
    '.button--primary',
    '.claim-button',
    '.field__button',
    '.theme-button',
    '.guarantee-section__cta',
    '.custom-hero__button',
    '.rich-text-button'
  ];

  // Function to apply effects to buttons
  function applyButtonEffects() {
    buttonSelectors.forEach(selector => {
      const buttons = document.querySelectorAll(selector);
      buttons.forEach(button => {
        // Skip buttons that explicitly opt out or cart remove buttons
        if (button.classList.contains('button-section-override') ||
            button.classList.contains('no-enhanced-effects') ||
            button.classList.contains('cart-remove-button') ||
            button.classList.contains('button--tertiary') ||
            button.classList.contains('disable-global-button-styling')) {
          return;
        }

        // Apply box shadow effect if enabled
        if (enableBoxShadow) {
          button.classList.add('button-box-shadow');
          button.classList.add(`intensity-${shadowIntensity}`);
        }

        // Apply gradient effect if enabled
        if (enableGradient) {
          button.classList.add('button-gradient-effect');

          // Apply shine effect conditionally
          if (enableGradientShine) {
            button.classList.add('gradient-shine-enabled');
          } else {
            button.classList.remove('gradient-shine-enabled');
          }
        }
      });
    });
  }

  // Apply effects immediately (script is deferred, so DOM is ready)
  applyButtonEffects();

  // Re-apply effects when new content is loaded (for AJAX/dynamic content)
  const observer = new MutationObserver(function(mutations) {
    let shouldReapply = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node contains buttons
          if (node.querySelector && buttonSelectors.some(selector => node.querySelector(selector))) {
            shouldReapply = true;
          }
          // Check if the added node itself is a button
          if (buttonSelectors.some(selector => node.matches && node.matches(selector))) {
            shouldReapply = true;
          }
        }
      });
    });

    if (shouldReapply) {
      setTimeout(applyButtonEffects, 50); // Small delay to ensure DOM is ready
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
